import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Avatar from 'components/Avatar';
import FormGroup from 'components/Form/FormGroup';
import messages from '../../../messages';
import styles from '../../../OrganizationLogo.pcss';
const Logo = ({ formValues })=>{
    const { logo, name } = formValues.values;
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "logo",
        labelMessage: messages.labels.logo,
        formValues: formValues,
        isOneLiner: true,
        children: /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: logo,
            name: name,
            size: 40,
            className: styles.logo
        })
    });
};
export default Logo;
